import {
  TechSpecIdentifier,
  TechSpecsSelectorProps
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { fn } from "storybook/test"

import techSpecs from "./techSpecs"

const techSpecsSelector: TechSpecsSelectorProps = {
  modal: {
    isOpen: false,
    onClose: fn()
  },
  onSelectClick: fn(),
  onSetTechSpecs: fn(),
  techSpecsAvailable: [
    {
      serviceName: "avForums",
      techSpecs: [techSpecs[0]]
    },
    {
      serviceName: "bluRay",
      techSpecs
    }
  ],
  techSpecsSelected: [
    [
      "AudioLanguageEnglish" as TechSpecIdentifier.AUDIO_LANGUAGE_ENGLISH,
      "AudioFormatDTS:X" as TechSpecIdentifier.AUDIO_FORMAT_DTS_X
    ]
  ]
}

export default techSpecsSelector
